module.exports = "/img/_/_/_/assets/images/creeper/battle/legendary//2.jpg?23500fdb14f03b7f6c0a2b8eb68f6277";